"use client";

import * as React from "react";
import { useWalletInfoContext } from "../providers/wallet-info-provider";

export interface WalletInfoFooterProps {
  children: React.ReactNode;
}

export function WalletInfoFooter({ children }: WalletInfoFooterProps) {
  const { setFooterContent } = useWalletInfoContext();

  React.useEffect(() => {
    setFooterContent(children);
    return () => setFooterContent(null);
  }, [children, setFooterContent]);

  return null;
}
